import React from 'react';
import { Provider } from 'react-redux';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import {
  AnimatedCoins,
  Box,
  ThemeProvider,
  toastConfig,
} from '@bonanza-social/moonlight';
import { PersistGate } from '@bonanza-social/toolkit/state';
import { SplashScreen } from '@bonanza-social/navigation';
import router from './Router';

import { persistor, store } from '@bonanza-social/toolkit/store';
import Toast from 'react-native-toast-message';

import './modals';
import { RouterProvider } from 'react-router';

function App() {
  return (
    <GestureHandlerRootView>
      <SafeAreaProvider>
        <ThemeProvider>
          <Provider store={store}>
            <PersistGate loading={<SplashScreen />} persistor={persistor}>
              <RouterProvider router={router} />
            </PersistGate>
          </Provider>
          <Box position="absolute" top="space-0" width="100%" zIndex={3}>
            <Toast config={toastConfig} autoHide visibilityTime={4000} />
          </Box>
          <AnimatedCoins />
        </ThemeProvider>
      </SafeAreaProvider>
    </GestureHandlerRootView>
  );
}

export default App;
